
export const environment = {
    production: false,
    apiUrl: "https://api-develop-menuvia.haniftech.net/api",
  };
  